const keys = {
  driverAssignment: {
    subtitle: 'A main driver is required',
  },
};

export default keys;

export type TranslationKeys = typeof keys;
